import { commitMutation, graphql } from 'react-relay';
import environment from '../data/environment';

const mutation = graphql`
  mutation UpdateReportConfigMutation(
    $input: UpdateReportConfigInput!
  ) {
    updateReportConfig(input: $input) {
      report {
        id
        name
        folder
        groupByLocation
        showTagsFilter
        devices {
          id
          name
          location
        }
        filters {
          text {
            language
            text
          }
          locked
        }
      }
    }
  }
`;

function commit({ reportId, name, folder, groupByLocation, showTagsFilter, devices, filters }, callback) {
  commitMutation(
    environment,
    {
      mutation,
      variables: {
        input: {
          reportId,
          name,
          folder,
          groupByLocation,
          showTagsFilter,
          devices,
          filters,
        },
      },
      onCompleted: (res) => {
        callback(null, res);
      },
      onError: (err) => {
        callback(err);
      },
    },
  );
}

export default { commit };



// WEBPACK FOOTER //
// ./src/mutations/UpdateReportConfigMutation.js